import styled from 'styled-components';

const OptionButton = styled.div`
  display: flex;
  width: 200px;
  padding: 8px 16px;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  border-radius: 8px;
  border: 1.5px solid
    ${({ theme, active }) => (active ? theme.primaryDark : theme.dark70)};
  background: ${({ theme, active }) => (active ? theme.primary : theme.white)};
  &:hover {
    border: 1.5px solid ${({ theme }) => theme.primaryDark};
  }
`;

const OptionText = styled.div`
  color: ${({ theme, active }) => (active ? theme.white : theme.bodyMedium)};
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
  letter-spacing: -0.2px;
`;

const FormLabel = styled.div`
  color: ${({ theme }) => theme.heading};
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
  margin-bottom: 5px;
`;

const StyledColorIcon = styled.span`
  color: ${({ theme }) => theme.primary};
  border-color: ${({ theme }) => theme.primary}!important;
`;

const OptionEditBg = styled.div`
  width: 494px;
  display: flex;
  flex-direction: column;
  padding: 24px 20px;
`;

const NavBarOptionBg = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  border-top: 1px solid ${({ theme }) => theme.dark70};
  padding: 10px 0px;
`;

const NavPageAddButtonBg = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  border-radius: 0px 0px 8px 8px;
  border-top: 1px solid ${({ theme }) => theme.dark70};
  background: #fff;
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.08),
    0px 0px 6px 0px rgba(0, 0, 0, 0.02);
`;

const EditOptionButtonBg = styled.div`
  display: flex;
  width: 454px;
  padding: 8px 16px;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  border-radius: 8px;
  border: 1.5px solid
    ${({ theme, active }) => (active ? theme.primaryDark : theme.dark70)};
  background: ${({ theme, active, isHidden }) =>
    isHidden ? theme.dark70 : active ? theme.primary : theme.white};
`;

const NavEditBg = styled.div`
  display: flex;
  width: 446px;
  padding: 8px 16px;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  border-radius: 8px;
  border: 1.5px solid
    ${({ theme, active }) => (active ? theme.primary : theme.dark70)};
  background: ${({ theme, isHidden }) =>
    isHidden ? theme.dark70 : theme.white};
`;

const BorderButton = styled.div`
  cursor: pointer;
  display: flex;
  padding: 9.5px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  border: 2px solid ${({ theme }) => theme.primary};
  background: #fff;
  color: ${({ theme }) => theme.heading};
  text-align: center;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
`;

const DropDownBackground = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.08),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
`;

const DropDownOptions = styled.div`
  display: flex;
  width: 228px;
  padding: 8px 16px;
  align-items: center;
  gap: 16px;
`;

const TextNormal = styled.div`
  color: ${({ theme }) => theme.heading};
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
`;

const MenuEditBg = styled.div`
  background: #fff;
  width: 501px;
  border-left: 1.5px solid ${({ theme }) => theme.dark70};
  padding: 24px 20px;
`;

const TabsBg = styled.div`
  width: 494px;
  display: flex;
  flex-direction: column;
  padding: 24px 20px;

  button {
    color: ${({ theme }) => theme.bodyMedium};
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
  }
`;

const ColorPopUpBg = styled.div`
  flex-shrink: 0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 16px 32px 0px rgba(0, 0, 0, 0.08),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
  width: 320px;

  .gradient-cutom-style {
    margin: 0 auto !important;
    padding: 15px 0;
  }
  div[class*='core_rbgcpCanvasWrapper'] {
    height: 180px !important;
    canvas {
      width: 100% !important;
      height: 100% !important;
    }
  }
`;

const ModalContainer = styled.div`
  .modal.modal-fullscreen .modal-dialog {
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 0;
    max-width: none;
  }

  .modal.modal-fullscreen .modal-content {
    height: auto;
    height: 100vh;
    border-radius: 0;
    border: none;
  }

  .modal.modal-fullscreen .modal-body {
    overflow-y: auto;
  }
`;

const LoaderBg = styled.div`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  border-radius: 8px;
  background: linear-gradient(
    270deg,
    rgba(0, 0, 0, 0.56) 0%,
    rgba(0, 0, 0, 0.56) 100%
  );
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
`;

const HorizontalSeprater = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.dark70};
  margin: 5px 0px;
`;

const EditMenuAddNewPage = styled.div`
  padding: 20px 24px;
  display: flex;
  justify-content: flex-end;
`;

export const TemplateTheming = {
  OptionButton,
  OptionText,
  FormLabel,
  StyledColorIcon,
  NavBarOptionBg,
  NavPageAddButtonBg,
  OptionEditBg,
  EditOptionButtonBg,
  BorderButton,
  DropDownBackground,
  DropDownOptions,
  TextNormal,
  MenuEditBg,
  TabsBg,
  ColorPopUpBg,
  ModalContainer,
  LoaderBg,
  HorizontalSeprater,
  EditMenuAddNewPage,
  NavEditBg,
};
